export default "__VITE_ASSET__COh6kgM6__"